import React from 'react';
import PropTypes from 'prop-types';
import TableReport from '@componentes/TableReport';
import Table from './Table';
import IntlMessage from '../../../../helpers/intlMessage';

function ImpressaoReceptaculos ({ lista }) {
  return (
    <TableReport
      title={<IntlMessage id = "dashboards.taskControl.receptacleControl"/>}
      assinatura={<IntlMessage id = "dashboards.taskControl.responsibleMacro"/>}
      assinatura2={<IntlMessage id = "dashboards.taskControl.technicalManager"/>}
      children={lista}
    >
      {lista.map((item, i) => (
        <tr key={i} style={{ border: 0 }}>
          <td style={{ border: 0, padding: 0 }}>
            <Table item={item} />
          </td>
        </tr>
      ))}
    </TableReport>
  );  
}

ImpressaoReceptaculos.propTypes = {
  lista: PropTypes.array.isRequired
};

ImpressaoReceptaculos.defaultProps = {
  lista: []
};

export default ImpressaoReceptaculos;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Recptaculos/Impressao/index.js